import { createComponent } from '@carvana/merch-components';

export const TileWrapper = createComponent('div', {
  className:
    'flex h-[116px] flex-1 flex-col justify-between rounded-md border border-grey-2 p-16 text-grey-5'
});

export const TileTopSectionWrapper = createComponent('div', {
  className: 'flex flex-row'
});

export const TileTopSectionContent = createComponent('div', {
  className: 'relative flex flex-1 flex-col gap-4'
});

export const Pill = createComponent('div', {
  className: 'flex h-[24px] items-center rounded-lg px-8 tl-label-xs'
});
